<template>
  <div class="flex items-center flex-wrap w-full">
    <select-button
      v-for="option in options"
      :key="option.key"
      class="px-1 h-full"
      v-model="selection"
      :option-value="option.key"
      @input="selectionChanged"
      >{{ option.name }}
    </select-button>
    <div class="w-full flex mt-2" v-if="error">
      <svg class="h-5 w-5 mr-1 text-red-500" fill="currentColor" viewBox="0 0 20 20">
        <path
          fill-rule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
          clip-rule="evenodd"
        />
      </svg>
      <p class="text-sm text-red-600">{{ error }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: { type: Array },
    value: {},
    error: { type: String, default: '' },
  },
  created() {
    this.selection = this.value;
  },
  data() {
    return {
      selection: null,
    };
  },
  methods: {
    selectionChanged(value) {
      this.$emit('input', value);
    },
  },
  watch: {
    value(newVal) {
      this.selection = newVal;
    },
  },
};
</script>
